import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { BonesApp } from '../components/apps/apps/BonesApp';
export function BonesPage() {
    const mockContext = {
        onClose: () => {
            window.history.back();
        }
    };
    return (_jsx("div", { className: "h-full", children: _jsx(BonesApp, { context: mockContext }) }));
}
